import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { themeV2 } from '@features/executive-report/domain/theme-v2';
import { buildChartMetadata } from '@features/executive-report/subdomains/visitation/slides/more-stats';
import { slideMasters } from '@features/executive-report/utils/slide-masters';
import { Slide } from '@features/powerpoint';
import { cardBackground } from './components/card-background';

const colors = [
  themeV2.colors.lightBlue,
  themeV2.colors.inmarketGreen,
] as const;

type SlideProps = {
  proximityToHome: CampaignAnalyticsReport['proximityToHome'];
  visitsByHourOfDay: CampaignAnalyticsReport['visitsByHourOfDay'];
  visitsByDayOfWeek: CampaignAnalyticsReport['visitsByDayOfWeek'];
  timeToFirstVisitByDay: CampaignAnalyticsReport['timeToFirstVisitByDay'];
};

export const moreStatsSlide = (props: SlideProps): Slide => {
  const moreStatsSlidePartials = buildChartMetadata({
    ...props,
    styleMetadata: {
      getChartBackground: () => cardBackground({}),
      colors,
      xAxisLabelColor: themeV2.colors.metricBlue,
      hideTitleUnits: true,
      dataLabelColor: themeV2.colors.metricBlue,
      boldTitle: true,
    },
  });

  return {
    slideMaster: slideMasters.light,
    color: themeV2.colors.metricBlue,
    texts: [
      {
        text: 'More Stats',
        options: {
          fontSize: 36,
          bold: true,
          h: 0.75,
          w: 12.67,
          x: 0.33,
          y: 0.38,
        },
      },
      ...moreStatsSlidePartials.flatMap(p => p.texts ?? []),
    ],
    shapes: moreStatsSlidePartials.flatMap(p => p.shapes ?? []),
    charts: moreStatsSlidePartials.flatMap(p => p.charts ?? []),
  };
};
